import { IState } from '../types/state';

const resetActiveEvent = (state: IState) => {
  state.activeSpecialEvent.data = null;
};

export default resetActiveEvent;
